import {
  Paper,
  PaperPaddings,
  type PaperProps,
  Separator,
} from '@carboncopyco/ui';
import classNames from 'classnames';
import type React from 'react';

export type TitleCardProps = {
  header: React.ReactElement;
} & PaperProps;

export const TitleCard = ({
  header,
  children,
  padding,
  radius = true,
  shadow,
  border = 'ds-regular',
}: TitleCardProps) => {
  return (
    <Paper
      radius={!!radius}
      shadow={shadow}
      border={border}
    >
      <div className="flex flex-col">
        <div
          className={classNames({
            [PaperPaddings[padding!]]: padding,
          })}
        >
          {header}
        </div>
        <Separator horizontal />
        <div
          className={classNames('grow', {
            [PaperPaddings[padding!]]: padding,
          })}
        >
          {children}
        </div>
      </div>
    </Paper>
  );
};
